module.exports = __webpack_public_path__ + "img/venture-capital.2ecfd40.svg";